import {IAccountsState} from '@app/accounts/models/accounts.model';
import {ICustomersState} from '@app/accounts/models/customer-state.model';
import {accountsReducer, customersReducer} from '@app/accounts/states/accounts.reducer';
import {ICategoryListState} from '@app/category/models/category-list-state.model';
import {categoryListReducer} from '@app/category/state/category-list.reducers';
import {ICancelOrderState} from '@app/checkout/models/cancel-order-state.model';
import {IConsentPdfState} from '@app/checkout/models/consent-pdf-state.model';
import {ICookiePolicyState} from '@app/cookie-consent/models/cookie-policy-state.model';
import {cookiePolicyReducer} from '@app/cookie-consent/state/cookie-policy.reducer';
import {IMaintenanceModeState} from '@app/maintenance-mode/models/maintenance-mode-state.model';
import {maintenanceModeReducer} from '@app/maintenance-mode/state/maintenance-mode.reducer';
import {myOrderReducer} from '@app/order/components/state/my-order.reducer';
import {IMyOrderState} from '@app/order/models/my-order-state.model';
import {IPageNotFoundState} from '@app/page-not-found/models/page-not-found-state.model';
import {pageNotFoundReducer} from '@app/page-not-found/state/page-not-found-reducer';
import {IMultiSelectState, ISelectState} from '@app/shared/models/dynamic-form.model';
import {IHeaderState} from '@app/shared/models/header.model';
import {ILanguageState} from '@app/shared/models/language.model';
import {ISearchState} from '@app/shared/models/search-state.model';
import {multiSelectReducer, selectReducer} from '@app/shared/state/dynamic-form/dynamic-form.reducer';
import {headerReducer} from '@app/shared/state/header/header.reducer';
import {languageReducer} from '@app/shared/state/language/language.reducer';
import {searchReducer} from '@app/shared/state/search/search.reducers';
import {IStaticPageState} from '@app/static-pages/model/static-pages-state.model';
import {staticPageReducer} from '@app/static-pages/state/static-pages.reducer';
import {ActionReducerMap} from '@ngrx/store';
import {IAuthState} from 'src/app/auth-config/models/auth-state.model';
import {authReducer} from 'src/app/auth-config/state/auth.reducer';
import {ICheckoutState} from 'src/app/checkout/models/checkout.state.model';
import {cancelOrderReducer, checkoutReducer, consentPdfReducer} from 'src/app/checkout/state/checkout.reducer';
import {ISignUpState} from 'src/app/signUp/models/sign-up-state.model';
import {signUpReducer} from 'src/app/signUp/state/sign-up.reducer';

import {FeatureFlagState} from '@app/core/models/feature-flag-state.model';
import {featureFlagReducer} from '@app/core/state/feature-flag.reducer';
import {INewOrderState} from '@app/product/models/new-order-state.model';
import {newOrderReducer} from '@app/product/state/new-order.reducer';

// Order alphabetically
export enum EState {
  Accounts = 'accountsState',
  Auth = 'authState',
  CancelOrder = 'cancelOrderState',
  CategoryList = 'categoryListState',
  Checkout = 'checkoutState',
  ConsentPdf = 'consentPdfState',
  CookiePolicy = 'cookiePolicyState',
  Customers = 'customersState',
  Header = 'headerState',
  Language = 'languageState',
  MaintenanceMode = 'maintenanceModeState',
  MultiSelect = 'multiSelectState',
  MyOrders = 'myOrdersState',
  newOrder = 'newOrderState',
  PageNotFound = 'pageNotFoundState',
  Search = 'searchState',
  Select = 'selectState',
  SignUp = 'signUpState',
  StaticPages = 'staticPagesState',
  FeatureFlags = 'featureFlagsState',
}

// Order alphabetically
export interface State {
  accountsState: IAccountsState;
  authState: IAuthState;
  cancelOrderState: ICancelOrderState;
  categoryListState: ICategoryListState;
  checkoutState: ICheckoutState;
  consentPdfState: IConsentPdfState;
  cookiePolicyState: ICookiePolicyState;
  customersState: ICustomersState;
  headerState: IHeaderState;
  languageState: ILanguageState;
  maintenanceModeState: IMaintenanceModeState;
  multiSelectState: IMultiSelectState;
  myOrdersState: IMyOrderState;
  newOrderState: INewOrderState;
  pageNotFoundState: IPageNotFoundState;
  searchState: ISearchState;
  selectState: ISelectState;
  signUpState: ISignUpState;
  staticPagesState: IStaticPageState;
  featureFlagsState: FeatureFlagState;
}

// Order alphabetically
export const rootReducer: ActionReducerMap<State> = {
  accountsState: accountsReducer,
  authState: authReducer,
  cancelOrderState: cancelOrderReducer,
  categoryListState: categoryListReducer,
  checkoutState: checkoutReducer,
  consentPdfState: consentPdfReducer,
  cookiePolicyState: cookiePolicyReducer,
  customersState: customersReducer,
  headerState: headerReducer,
  languageState: languageReducer,
  maintenanceModeState: maintenanceModeReducer,
  multiSelectState: multiSelectReducer,
  myOrdersState: myOrderReducer,
  newOrderState: newOrderReducer,
  pageNotFoundState: pageNotFoundReducer,
  searchState: searchReducer,
  selectState: selectReducer,
  signUpState: signUpReducer,
  staticPagesState: staticPageReducer,
  featureFlagsState: featureFlagReducer,
};
